module.exports = [
    [   // 0 months to 6 months questionair
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        ''
    ],
    [   // 6 months to 3 years questionair
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        ''
    ],
    [   // 3 years to 14 years questionair
        'واکنش شدیدی به صداهای بلند یا غیر منتظره نشان می‌دهد؟ (به عنوان مثال آژیر، واق واق سگ، سشوار)',
        'جهت جلوگیری از شنیدن صداها، دست‌هایش را روی گوش‌هایش می‌گذارد',
        'وقتی تلویزیون روشن است در انجام کارها تقلا می‌کند',
        'وقتی صدای زیادی در اطراف است، حواسش پرت می‌شود',
        'وقتی صدای محیطی وجود داشته باشد، نمی‌تواند کارها را درست انجام دهد (به عنوان مثال پنکه، یخچال)',
        'به من گوش نمی‌دهد یا به نظر می‌آید که من را نادیده می‌گیرد',
        'به نظر می‌آید که وقتی اسمش را صدا می‌زنم، نمی‌شنود (با وجود اینکه شنوایی او سالم است)',
        'از صداهای عجیب و غریب لذت می‌برد یا صداهایی را برای لذت خودش در می‌آورد',

        'ترجیح می‌دهد در محیطی با نور کم بازی یا فعالیت کند',
        'رنگ یا الگوهای روشن را برای لباس پوشیدن ترجیح می‌دهد',
        'از قفل شدن نگاهش روی جزئیات اشیاء لذت می‌برد',
        'برای پیدا کردن وسایلی که برای دیگران آشکار هستند، نیاز به کمک دارد',
        'نسبت به هم سن و سالان خود توسط نورهای روشن بیشتر اذیت می‌شود',
        'وقتی افراد در سطح اتاق حرکت می‌کنند، آن‌ها را تماشا می‌کند',

        'توسط نورهای روشن اذیت می‌شود (به عنوان مثال از نور خورشید بیرون زده از پنجره ماشین، خود را پنهان می‌کند)',

        'هنگام آراستن، احساس اضطراب نشان می‌دهد (به عنوان مثال موقع کوتاه کردن مو، شستن صورت و گرفتن ناخن‌ها گریه می‌کند یا دعوا راه می‌اندازد)',
        'هنگام پوشیدن جوراب یا کفش، رنجیده می‌شود',
        'نسبت به لمس شدن حساس یا پرخاشگر می‌شود',
        'وقتی نزدیک به دیگران دیگران می‌ایستد دچار اضطراب می‌شود (به عنوان مثال، در یک صف)',
        'قسمتی از بدنش که لمس می‌شود را پاک می‌کند یا می‌خاراند',
        'دیگران را تا حدی که موجب آزار آن‌ها می‌شود لمس می‌کند',
        'نسبت به لمس اسباب‌بازی‌ها، سطوح یا بافت‌ها احساس نیاز نشان می‌دهد (به عنوان مثال می‌خواهد همه چیز را لمس کند)',
        'نسبت به درد ناآگاه به نظر می‌رسد',
        'نسبت به تغییرات دما ناآگاه به نظر می‌رسد',
        'نسبت به هم سن و سالان خود افراد یا اشیاء را بیشتر لمس می‌کند',
        'نسبت به دستان یا صورت کثیف بی توجه به نظر می‌رسد',

        'حرکات را تا جایی دنبال می‌کند که با روتین روزانه‌اش تداخل داشته باشد (به عنوان مثال نمی‌تواند آرام بنشیند، یا فیدجت‌ها)',
        'در حالت نشسته روی صندلی یا روی زمین یا در حالت ایستاده تکان‌تکان می‌خورد',
        'در بالا رفتن از پله‌ها یا موانع تعلل می‌کند (به عنوان مثال قبل از حرکت بسیار محتاط است)',
        'طی فعالیت‌های حرکتی هیجان زده می‌شود',
        'در حرکات یا بالارفتن‌هایش دارای ریسک غیر امن است',
        'به دنبال فرصتی برای افتادن بدون در نظر گرفتن حفظ امنیت خود است (به عنوان مثال عمدا از جایی به پایین می‌پرد)',
        'تعادل خود را به طور غیر منتظره‌ای هنگام راه رفتن در سطحی غیر مسطح از دست می‌دهد',
        'به چیزهای مختلف برخورد می‌کند، متوجه افراد یا اشیاء سر راهش نمی‌شود',

        'به گونه‌ای خشک حرکت می‌کند',
        'به راحتی خسته می‌شود، به خصوص وقتی ایستاده است یا می‌خواهد بدنش را در حالتی نگه دارد',
        'به نظر می‌رسد عضلات ضعیفی دارد',
        'برای خفظ تعادلش، لم می‌دهد (به عنوان مثال سرش را روی دستش می‌گذارد، به دیوار تکیه می‌دهد)',
        'به اشیاء، دیوارها یا نرده‌ها بیش از هم سن و سالان خود می‌چسبد',
        'با سر و صدا راه می‌رود، انگار که پاهای سنگینی دارد',
        'خودش را روی روی مبل یا سایر افراد دراز می‌اندازد',
        'به پتوهای ضخیم جهت خواب نیاز دارد',

        'به راحتی با یک سری بافت‌های غذایی یا ورود قاشق و چنگال به دهان، اوق می‌زند',
        'مزه و بوی غذاهای مشخصی را که بخشی از برنامه غذایی عادی کودکان هستند، پس می‌زند',
        'فقط مزه‌های مشخصی را می‌خورد (به عنوان مثال شیرین، شور)',
        'خودش را به بافت‌های غذایی مشخصی محدود می‌کند',
        'در مورد غذا خوردن بسیار سختگیر است، به خصوص در مورد بافت غذاها',
        'اشیائی به جز غذا را بو می‌کشد',
        'مزه‌های مشخصی را به شدت ترجیح می‌دهد',
        'به غذاها، مزه‌ها و بوهای مشخصی اشتیاق نشان می‌دهد',
        'اشیاء را در دهانش می‌گذارد (به عنوان مثال مداد، دست‌هایش)',
        'زبان یا لب‌ش را نسبت به هم سن و سالان خود، بیشتر گاز می‌گیرد',

        'به نظر مستعد تصادف می‌آید',
        'در رنگ زدن، نوشتن یا نقاشی کردن عجله می‌کند',
        'ریسک‌های بیش از اندازه می‌کند (به عنوان مثال از درخت بالا می‌رود، از روی مبل‌های بلند به پایین می‌پرد) به طوری که امنیتش را به خطر می‌اندازد',
        'فعال‌تر از هم سن و سالان خود به نظر می‌آید',
        'کارها را به روشی سخت‌تر از آن چه نیاز است انجام می‌دهد (به عنوان مثال زمان تلف می‌کند، به آرامی حرکت می‌کند)',
        'یک دنده است و همکاری نمی‌کند',
        'دارای بدخَلقی می‌باشد',
        'به نظر می‌رسد از افتادن خوشش می‌آید',
        'از تماس چشمی با من یا دیگران مقاومت می‌کند',

        'به نظر می‌رسد اعتماد به نفس پایینی دارد (به عنوان مثال به خودش اعتماد ندارد)',
        'نیاز به حمایت مثبت دارد تا در موقعیت‌های چالشی قرار گیرد',
        'نسبت به انتقاد حساس است',
        'ترس‌های واضع و قابل پیش بینی دارد',
        'احساساتش را مثل یک شکست بیان می‌کند',
        'خیلی جدی می‌باشد',
        'به لحاظ احساسی منفجر می‌شود وقتی نمی‌تواند یک تَسک را کامل کند',
        'در تفسیر زبان بدن یا حالت‌های صورت مشکل دارد',
        'به راحتی ناامید می‌شود',
        'ترس‌هایی دارد که کارهای روزانه‌اش را مختل می‌کند',
        'با تغییر در برنامه‌ها، روتین‌ها و انتظاراتش، پریشان می‌شود',
        'نسبت به هم سن و سالان خود در زندگی نیاز به محافظت بیشتری دارد (به عنوان مثال به لحاظ فیزیکی یا احساسی بی‌دفاع است)',
        'نسبت به هم سن و سالان خود کمتر در گروه‌ها شرکت می‌کند یا با آن‌ها تعامل دارد',
        'در دوستی‌ها مشکل دارد (به عنوان مثال پیدا کردن یا ادامه دادن دوستی)',

        'از تماس چشمی با من طی فعالیت‌های روزانه پرهیز می‌کند',
        'به سختی توجه می‌کند',
        'از کارهایی که به او می‌دهم روی بر می‌گرداند تا به اتفاقات داخل اتاق توجه کند',
        'در یک محیطِ پر از اتفاقات، بی توجه به همه چیز به نظر می‌رسد (به عنوان مثال، متوجه فعالیت‌ها نمی‌شود)',
        'به مقدار زیاد به اشیاء خیره می‌شود',
        'به مقدار زیاد به افراد خیره می‌شود',
        'به همه‌ی افرادی که در یک اتاق حرکت می‌کنند نگاه می‌کند',
        'از یک چیز به چیز دیگری می‌پرد به طوری که با فعالیت فعلی او در تداخل است',
        'به راحتی گم می‌شود',
        'به سختی اشیاء را در یک پس‌زمینه‌ی نزدیک به آن شیء پیدا می‌کند (به عنوان مثال کفش‌هایش را در اتاقی شلوغ، مدادش را در کشویی شلوغ)',
        'وقتی فردی وارد اتاق می‌شود، به نظر متوجه نمی‌شود'
    ]
]